import {combineReducers} from 'redux';
import AuthReducer from './AuthReducer';
import NewMessagesReducer from './NewMessagesReducer';
// import {reducer as reduxForm} from 'redux-form';
import InventoryReducers from './InventoryReducers';
import ClinicReducer from './ClinicReducer';
import {
  OrderHistorySearchReducer,
  OrderHistoryDateReducer
} from './OrderHistoryReducers';
import InventorySearchReducers from './InventorySearchReducers';
import PaymentsReducer from './PaymentsReducer';
import PatientRecallReducer from './PatientRecallReducer';
import PatientDrawerReducer from './PatientDrawerReducer';
import GroupReducer from './GroupReducer';
import CardMachineReducer from './CardMachineReducer';
import {CCMTimerReducer} from './CCMTimerReducer';
import ReportsReducer from './ReportsReducer';
import AppointmentSchedularReducer from './AppointmentSchedularReducer';
import SubscriptionChargesReducer from './SubscriptionChargesReducer';
import {TicketTimerReducer} from './TicketTimerReducer';
import PriorAuthorizationsReducer from './PriorAuthorizationsReducer';
import ClaimsTicketsReducer from './ClaimsTicketsReducer';
import ReferralsTicketsReducer from './ReferralsTicketsReducer';

const appReducer = combineReducers({
  // form: reduxForm,
  auth: AuthReducer,
  inventory: InventoryReducers,
  newMessages: NewMessagesReducer,
  searchInventory: InventorySearchReducers,
  orderHistory: OrderHistorySearchReducer,
  orderHistoryDate: OrderHistoryDateReducer,
  clinics: ClinicReducer,
  payments: PaymentsReducer,
  patientRecall: PatientRecallReducer,
  group: GroupReducer,
  cardMachine: CardMachineReducer,
  ccmTimer: CCMTimerReducer,
  patientDetailsDrawer: PatientDrawerReducer,
  reports: ReportsReducer,
  appointmentPortal: AppointmentSchedularReducer,
  subscriptionCharges: SubscriptionChargesReducer,
  PriorAuthTicketTimer: TicketTimerReducer,
  PriorAuthorizations: PriorAuthorizationsReducer,
  ClaimsTickets: ClaimsTicketsReducer,
  ReferralsTickets: ReferralsTicketsReducer
});

// Meant for any global state changes (if any)
const rootReducer = (state: any, action: any): any => {
  return appReducer(state, action);
};
export type State = ReturnType<typeof appReducer>;

export default rootReducer;
